import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import CallInfo from '../../component/CallInfo';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import AccountList from '../../component/Account/AccountList';
import Information from '../../component/Information';
import Main_Spring from '../../component/Spring/Main_Spring';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import ParentInfo from '../../component/Info/ParentInfo';
import musicTitle from '../../asset/music/justFilm.mp3'


const HamSooKwon = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "함수권❤️탁서이 결혼합니다.";
    const openDesc = "5월 3일 토요일 12:00";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/176/thumb.jpg";

    const lng = 127.18492496605;
    const lat = 37.3302724928238;

    const placeTelNum = "0313369570";

    // const forCar = " 순천 IC로 진입 > 구례, 주암방면 > 백강로\n> 압곡길 > 아모르웨딩 컨벤션 주차장\n\n네비게이션 검색시 [아모르컨벤션] 또는 \n[전라남도 순천시 서면 압곡리 607 ]로 검색하세요.\n\n아모르웨딩컨벤션 TEL ) 061-752-1000\n전남순천시 서면 압곡길 94 (압곡리607)";
    // const forPublic = " • 순천역에서 오시는 길 \n택시 약 15분 소요 / 버스 약 25분 소요\n59번 버스: 순천역 서측(하)정류장 승차 > 압곡, 화정 \n정류장 하차 > 도보2분\n\n • 버스터미널에서 오시는 길\n택시 약 20분 소요 / 버스 약 30분 소요\n59번 버스: 종합버스터미널(하)정류장 승차 > 압곡, 화정 \n정류장 하차 > 도보2분"

    const parents = [
        {groom : "함용구 · 황미숙의 아들"},
        {bride : "탁양송 · 조정임의 딸"}
    ] 

    // const parentInfo = {
    //     groom: {
    //         dad: { name: "명남식", isDeceased: false },
    //         mom: { name: "안인순", isDeceased: true },
    //         role: "아들",
    //     },
    //     bride: {
    //         dad: { name: "이금하", isDeceased: false },
    //         mom: { name: "구은숙", isDeceased: false },
    //         role: "딸",
    //     }
    // };

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    // 연퍼플 #e4aced
    // 빈티지 연퍼플 #bf9cd8
    // 소라 : #88abd1
    // #edacb1
    // #D77599
    // #BC5078
    // #ff8faf

    // const conceptStyle = {
    //     // spring 블루A
    //     concept: "SPRING",
    //     titleColor: "#9FB4E7",
    //     pointColor: "#9FB4E7",
    //     btnBgColor: "#bfcfef",
    //     fontColor: "#313131",
    //     btnFontColor: "#313131",
    //     chatBgColor: "#f3f7ff",
    //     fontFamilyKo: "SCDream3",
    //     fontFamilyEn: "Edensor"
    // }
    const conceptStyle = {
        // 핑크A
        concept: "SPRING",
        titleColor: "#FF8A83",
        pointColor: "#FF8A83",
        btnBgColor: "#FFE8E7",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#fefaf9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const infoTitle = "우리 결혼합니다.";

    const msg1 = "봄 햇살이 함께 했던 지난날, \n 여러 해의 봄날 처럼 \n 앞으로도 햇살같은 봄날을 함께 하려 합니다.";
    const msg2 = "부디 귀한 시간 내주시어 저희의 봄날에 함께 \n 축복 해주시면 감사하겠습니다.";

    const groomAccountList = [
        {
            role: "신랑",
            name: "함수권",
            bank: "신한은행",
            accountNumber : "110-480-217785",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "함용구",
            bank: "국민은행",
            accountNumber : "232-21-0723-820",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "황미숙",
            bank: "농협은행",
            accountNumber : "351-0048-8614-83",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "탁서이",
            bank: "국민은행",
            accountNumber : "762302-04-160828",
            isKakao : false
        }
        ,{
            role: "신부 부",
            name: "탁양송",
            bank: "농협은행",
            accountNumber : "221023-56-042607",
            isKakao : false
        }
        // ,{
        //     role: "신부 모",
        //     name: "박내숙",
        //     bank: "신한은행",
        //     accountNumber : "705-06-059690",
        //     isKakao : false
        // }
    ]


    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "이승욱",
            call: "010-2786-9838"
        }
        ,{
            role: "신랑 부",
            name: "이복수",
            call: "010-5335-6083"
        }
        ,{
            role: "신랑 모",
            name: "허혜란",
            call: "010-9567-9847"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "한서희",
            call: "010-5802-2401"
        }
        ,{
            role: "신부 부",
            name: "한송만",
            call: "010-9145-9317"
        },
        {
            role: "신부 모",
            name: "윤미영",
            call: "010-5530-9317"
        }
    ]

    const interviewContent = [
        {
            question : "서로의 첫인상 기억해?",
            groomAnswer: "4차원소녀🧝🏻‍♀️",
            brideAnswer: "동글왕감자🥔"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "긴장반설렘반",
            brideAnswer: "두근콩닥콩닥"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "옆자리내꺼♥️",
            brideAnswer: "알라뷰쏘마치"
        },
        {
            question : "부부가 된 기념 한마디!",
            groomAnswer: "즐기며살자",
            brideAnswer: "나만따라와"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "모든분들",
            brideAnswer: "행복만가득♥️"
        }
    ]

    const informationList =[
        {
            title : "♥신랑신부가 준비한 포토부스 이벤트♥",
            content : "10시30분-12시 운영합니다! \n많이 참여해주세요\n\n예쁜사진과 축하메시지를 남겨주시고,\n인생사진도 마음껏 가져가세요 :D"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };


    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#FF8A83"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicTitle}/>
                    <Main_Spring groomNameEn={toUpperCaseString(weddingData.groomNameEn)} brideNameEn={toUpperCaseString(weddingData.brideNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
                    <Info_Spring2 parents={parents} weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
                    <Letter title={infoTitle} msg1={msg1} msg2={msg2} conceptStyle={conceptStyle}/>
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    {/* <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring isAttendFromClose={true} groomName={getFirstKoName(weddingData.brideName)} brideName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>    
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>    
                    <MotionWrapper initialY={50}>
                        {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>    
                    {/* <Location_Desc forCar={forCar} forPublic={forPublic} conceptStyle={conceptStyle}/> */}
                    {/* <Information titleFontSize={"15px"} pointFontColor={"#9b111e"} conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default HamSooKwon;